import matchesActiveIf from 'Pods/ThreeDStudio/Hooks/matchesActiveIf'
import { MODEL_SOURCES } from 'Pods/ThreeDStudio/Services/Constants/modelSources'
import { threeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setAvailableGenerationProviders } from 'Pods/ThreeDStudio/Store/actions/schema'

/**
 * Resolves the model schema that should drive the generation form, based on the
 * current action and model settings. As a side effect, syncs the store's
 * `availableGenerationProviders` (and possibly `generationProvider`) so that
 * the AI Engine selector reflects the providers eligible for this action.
 *
 * @param {string} generationAction - Current generation action (e.g. "image-to-3d").
 * @param {Object} modelSettings - Current model settings used to evaluate each
 *   schema's `active_if` constraints.
 * @returns {Object|undefined} The eligible schema for the active generation
 *   provider, or undefined when no schema matches.
 */
export const getNextGenerationSchema = (generationAction, modelSettings) => {
  const candidates = MODEL_SOURCES.filter((model) => model.action === generationAction)
  const eligible = candidates.filter(schema => matchesActiveIf(schema, modelSettings))
  const providers = [...new Set(eligible.map(schema => schema.provider))]
  setAvailableGenerationProviders(providers)
  const activeProvider = threeDStudioStore.getState().schema.generationProvider

  return eligible.find(schema => schema.provider === activeProvider)
}
